import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const ThreeRow = memo(({ label, subLabel, subSubLabel }) => {
    const theme = useTheme();
    const displayLabel = label || getLiteral('label_placeholder_unamed_record');

    return (
        <div>
            <Text type="body" isTruncated useTooltip>
                {displayLabel}
            </Text>
            <Text
                type="body"
                color={theme.colors.utility.textSecondary}
                isTruncated
                useTooltip
                as="div"
            >
                {subLabel}
            </Text>
            <Text
                type="caption"
                color={theme.colors.utility.textSecondary}
                isTruncated
                useTooltip
                as="div"
            >
                {subSubLabel}
            </Text>
        </div>
    );
});

ThreeRow.displayName = 'ThreeRow';

ThreeRow.propTypes = {
    label: PropTypes.node,
    subLabel: PropTypes.node,
    subSubLabel: PropTypes.node,
};

export default ThreeRow;
